import { Box, Spacer, Stack, Text } from '@chakra-ui/react'
import { faChevronRight, faTreeLarge } from '@fortawesome/pro-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import 'swiper/swiper-bundle.css'

import UserQ from '@/queries/UserQ'
import type { Query } from '@/client/query'
import { getTutorTreeUrl } from '@/client/services/url'

import ShwLink from '@/components/ShwLink'

import ProfileItemContainer from './ProfileItemContainer'

export default function ProfileTutorTree({ user }: { user: Query }): JSX.Element | null {
  const isUserTutor = user(UserQ.hasTutorRole()) ?? false
  const firstName = user(UserQ.first_name) ?? ''
  const username = user(UserQ.username)
  const userId = user(UserQ.id) ?? 0

  if (!isUserTutor) {
    return null
  }
  return (
    <Box>
      <ShwLink width="100%" href={getTutorTreeUrl(userId, username)}>
        <ProfileItemContainer>
          <Stack direction="row" spacing="24px" align="center">
            <Text color="gray.fg" fontSize="32px">
              <FontAwesomeIcon icon={faTreeLarge} />
            </Text>
            <Box>
              <Text variant="eyebrow" mb={2}>
                Tutor Tree
              </Text>
              <Text fontWeight={600}>See {firstName}&apos;s tutor tree</Text>
            </Box>
            <Spacer />
            <Text color="gray.fg">
              <FontAwesomeIcon icon={faChevronRight} />
            </Text>
          </Stack>
        </ProfileItemContainer>
      </ShwLink>
    </Box>
  )
}
